import { map, switchMap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { Invoice } from '../../model/invoice';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { Observable, of } from 'rxjs';
import { MessageService } from '../../../core/service/message.service';
import { InvoiceService } from '../data/invoice.service';

@Injectable()
export class DebtCollectionCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindow: ActionWindowService,
    private _dataService: InvoiceService,
    private _injector: Injector,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command && command.context instanceof Invoice) {
      return command.id === invoiceCommand.debtCollection;
    }

    if (command instanceof MultiselectCommand) {
      return command.items.length > 0;
    }

    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return this._messageService.showDialog('DEBT_COLLECTION.CREATE_CONFIRM').pipe(
        switchMap((dialogResult, index) => {
          if (dialogResult) {
            return this._dataService.sendToDebtCollection(command.context.id);
          }
        }),
        switchMap(res => {
          return of(null);
        })
      );
    }

    if (command instanceof MultiselectCommand) {
      return this._dataService.sendToDebtCollectionMany(command.items.map(item => item.id)).pipe(
        map(data => {
          command.items.forEach(item => {
            item.selected = false;
            Object.assign(
              item,
              data.find(x => x.id === item.id)
            );
          });
          return true;
        })
      );
    }

    if (command instanceof FilteredCommand) {
      return this._dataService
        .sendToDebtCollectionFilter(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(map(() => true));
    }
  }
}
